
<form #childForm="ngForm" class="form_customerFields">
  <p style="margin-top: -5px">
    {{'CUSTOMER_FIELDS.EXPLATION' | translate}}
  </p>
  
  <div class="ui-g container" provide-parent-form>
    <div class="p-fluid" *ngFor="let field of customerFields; let i = index" class="mb-4">
      <div class="r-form-group">
        <div class="field-header">
          <span class="field-label">
            {{ 'CUSTOMER_FIELDS.FIELD_NUMBER' | translate: { num: i + 1 } }}
          </span>
          <button pButton type="button" id="deleteField" styleClass="p-button-secondary" (click)="deleteField(field)">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>

      <div class="r-form-row">
        <div class="r-form-group">
          <label for="fieldName{{ i }}">
            {{'CUSTOMER_FIELDS.FIELD_NAME' | translate}}
          </label>
          <input required pInputText id="fieldName{{ i }}" #fieldName="ngModel" [(ngModel)]="field.FieldName"
            name="fieldName{{ i }}" />
          <div *ngIf="fieldName.errors?.required && fieldName.touched" class="error-required">
            {{ 'ERRORS.REQUIRED' | translate }}
          </div>
        </div>

        <!-- <div class="r-form-group">
          <label for="FieldNameInEnglish{{ i }}">
            {{'CUSTOMER_FIELDS.FIELD_TRANSLATION' | translate}}
          </label>
          <input required pInputText #fieldNameInEnglish="ngModel" id="FieldNameInEnglish{{ i }}"
            [(ngModel)]="field.FieldNameInEnglish" name="FieldNameInEnglish{{ i }}" />
          <div *ngIf="fieldNameInEnglish.errors?.required && fieldNameInEnglish.touched" class="error-required">
            {{ 'ERRORS.REQUIRED' | translate }}
          </div>
        </div> -->

        <div class="r-form-group">
          <label for="fieldType{{ i }}">
            {{'CUSTOMER_FIELDS.FIELD_TYPE' | translate}}
          </label>
          <p-dropdown  [options]="fieldTypes" optionLabel="label" optionValue="value"
            [(ngModel)]="field.FieldType" name="fieldType{{ i }}" [style]="{ width: '12rem' }"></p-dropdown>
        </div>
      </div>

      <div class="r-form-group" *ngIf="field.FieldType === customerFieldTypes.list">
        <label for="fieldOptions{{ i }}">
          {{'CUSTOMER_FIELDS.OPTIONS' | translate}}
        </label>
        <p-chips id="options" name="fieldOptions{{ i }}" [(ngModel)]="field.ArrayOptions" separator=","
          [style]="{ 'min-width': '97%', 'height': 'inital', 'min-height': '38px' }"
          class="clean-chips center-chips"></p-chips>
      </div>

      <!-- <div class="r-form-group" *ngIf="field.FieldType === customerFieldTypes.list">
        <label for="fieldOptionsInEnglish{{ i }}">
          {{'CUSTOMER_FIELDS.OPTIONS_IN_ENGLISH' | translate}}
        </label>
        <p-chips id="options" name="fieldOptionsInEnglish{{ i }}" [(ngModel)]="field.ArrayOptionsInEnglish"
          separator="," [style]="{ 'width': '97%', 'height': 'inital', 'min-height': '38px' }"
          class="clean-chips center-chips"></p-chips>
      </div> -->

      <div class="checkboxRequired">
        <p-checkbox class="checboxRequired" name="fieldRequired{{ i }}" [(ngModel)]="field.Required"
          (ngModelChange)="field.Required = $event" [binary]="true"></p-checkbox>
        <label for="fieldRequired{{ i }}">
          {{'CUSTOMER_FIELDS.REQUIRED' | translate}}
        </label>
      </div>
      <!-- <div class="preview-field" >
        <label>{{'CUSTOMER_FIELDS.PREVIEW' |translate}}</label>
        <label class="preview-label">{{ field.FieldName }}</label>
        <ng-container  >
          <input *ngIf="field.FieldType!=customerFieldTypes.list"
          [type]="getFieldType(field.FieldType)" 
          class="preview-input" disabled
          placeholder="{{ field.FieldNameInEnglish }}" />
          <p-dropdown *ngIf="field.FieldType==customerFieldTypes.list"
                      [options]="getPreviewOptions(field)"
                      placeholder="{{ field.FieldNameInEnglish }}"
                      class="preview-dropdown"></p-dropdown>
        </ng-container>
      </div>  -->
      <hr style="margin-top: 30px;" />
    </div>
    <button pButton type="button"  styleClass="p-button-secondary" (click)="addField()"
      [pTooltip]="'CUSTOMER_FIELDS.TOOLTIP' | translate" tooltipPosition="right" tooltipStyleClass="closer-tooltip">
      <i class="pi pi-plus-circle" style="font-size: x-large;"></i>
    </button>

    <button type="button" [disabled]="childForm.invalid" id="buttonUpdateFields" class="command-button full full-width"
      (click)="update()">
      {{'CUSTOMER_FIELDS.UPDATE' | translate}}
    </button>
  </div>
</form>